import React from 'react'
import ProductMiniItem from '../ProductMiniItem/index'
import PropTypes from 'prop-types'

const ProductMiniItemCollection = ({data}) => {
    
  return (
    <>
    {
        data.map((item, i)=>(
            <div className="col-xs-6 col-sm-12 col-md-6 col-lg-3" key={i} >
            <ProductMiniItem image={item.image} title={item.title} url={item.url} />
            </div>
        ))
    }
    </>
  )
}

ProductMiniItemCollection.propTypes = {
  data : PropTypes.arrayOf(
    PropTypes.shape({
      image : PropTypes.string.isRequired,
      title : PropTypes.string,
      url : PropTypes.string,
    })
  )
}

export default ProductMiniItemCollection